import ChevronRight from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const StyledChevronRight = styled(ChevronRight, { shouldForwardProp: prop => prop !== 'isExpanded' })<{
  isExpanded: boolean;
}>`
  transform: ${({ isExpanded }) => isExpanded && 'rotate(90deg)'};
`;

type ExpandButtonProps = {
  expanded: boolean;
};

export const ExpandButton = ({ expanded }: ExpandButtonProps) => {
  return (
    <IconButton
      key="arrowExpand"
      aria-label="arrowExpand"
      data-test="expand-icon"
      data-expandicon="expandRow"
      size="small"
      sx={{ mr: 2 }}
    >
      <StyledChevronRight isExpanded={expanded} color="primary" data-expandicon="expandRow" />
    </IconButton>
  );
};
